<template>
    <div v-if="!_isCheckout" class="header" :class="style()">
		<header-placeholder></header-placeholder>
        <mq-layout mq="desktop">
            <navigation/>
			<!-- <OrderTrackerContainer v-if="$route.name !== 'order-confirmation'" /> -->
			<!-- <adapted-component adapter-name="NavigationAnchorMenu" path="header" v-if="showAnchorNavigationRoute" /> -->
        </mq-layout>
        <mq-layout :mq="['mobile', 'tablet']">
			<app-header-navigation>
			</app-header-navigation>
			<transition name="fade-down">
				<header-checkout-bar v-if="hasItems()" />
			</transition> 
        </mq-layout>
    </div>
    <div v-else class="header" :class="style()">
		<app-header-navigation v-if="$mq !== 'desktop'">
		</app-header-navigation>
		<checkout-header v-if="$mq === 'desktop'"></checkout-header>
    </div>
</template>

<script>
	import EventBus from '@EventBus';
	import { includes } from 'lodash';
	import HeaderCart from '../HeaderCart.vue';
	import Navigation from '../Navigation.vue';
	import NavigationMobile from '../NavigationMobile.vue';
	import CheckoutHeader from "@/components/checkout/CheckoutHeader";
	import HeaderPlaceholder from '../HeaderPlaceholder.vue';
	import flowStateMixin from '@Mixin/flowStateMixin';
	import _Adapter from '@Adapter';
	import AppHeaderNavigation from './AppHeaderNavigation.vue';
	import cartMixin from '@Mixin/cartMixin';
	import routeMixin from '@Mixin/routeMixin';
	import headerMixin from '@Mixin/headerMixin';

	const OrderTrackerContainer = (resolve) => {
		require.ensure([], () => {
			resolve(require('@/components/orders/OrderTrackerContainer'));
		});
	};
	const HeaderCheckoutBar = (resolve) => {
		require.ensure([], () => {
			resolve(require('../HeaderCheckoutBar.vue'));
		});
	};

	export default {
		mixins: [flowStateMixin, cartMixin, routeMixin, headerMixin],
		components: {
			'header-placeholder': HeaderPlaceholder,
			'checkout-header': CheckoutHeader,
			'header-cart': HeaderCart,
			'header-checkout-bar': HeaderCheckoutBar,
			'navigation': Navigation,
			'navigation-mobile': NavigationMobile,
			'adapted-component': _Adapter,
			'app-header-navigation': AppHeaderNavigation,
			OrderTrackerContainer,
		},
		computed: {
			showAnchorNavigationRoute() {
				const route = this.$route;
				if (route.name === 'home') {
					return true;
				}
				return false;
			},
			checkHideRoute() {
				const hiddenRoutes = [];
				if (this.$layouts.hasSideBar(this.$mq)) {
					hiddenRoutes.push('order-confirmation');
				}
				return this.whiteListRoute(hiddenRoutes);
			}
		},
		methods: {
			showNavigationMenu() {
				const exitedFlows = this.exitedAllFlows;
				const route = this.$route;
				const atHome = (route.name === 'home');
				return (exitedFlows && atHome);
			},
			// TODO use style binding whenever possible
			style() {
				const route = this.$route.name;
				const isOrderConfirmation = this._isOrderConfirmation;
				const isMobile = (this.$mq === 'mobile');
				const isMobileCheckout = (this._isCheckout && isMobile);
				let styles = {
					'is-relative': isMobileCheckout,
					'order-confirmation': isOrderConfirmation,
					'hide': this.checkHideRoute,
				};
				styles[route] = true;
				return styles;
			},
			collapseAppHeader() {
				const headerOptions = this.$appConstants.header;
				const headerTranslate = (this.$mq === 'mobile') ? headerOptions.translateHeaderYMobile : headerOptions.translateHeaderY;
				this.$anime({
					targets: this.$el,
					duration: 333,
					translateY: headerTranslate || 0,
					easing: 'easeInOutCirc',
					changeComplete: (anim) => {
						this.updateHeader();
					}
				});
			},
			expandAppHeader() {
				this.$anime({
					targets: this.$el,
					duration: 333,
					translateY: '0',
					easing: 'easeInOutCirc',
					changeComplete: (anim) => {
						this.updateHeader();
					},
				});
			},
			updateHeader() {
				// TODO move into config for AppHeaderNavigation setItems
				if (this._isCheckout) {
					this._setHeaderItems([
						'back',
						'title',
						'account',
					]);
					this._setHeaderTitle('Checkout');
				}
				if (this._isOrderConfirmation) {
					this._setHeaderItems([
						'empty',
						'logo',
						'empty',
					]);
				}
				this._setHeaderHeight(this.$el.offsetHeight);
			},
		},
		mounted() {
			EventBus.$emit('recalculate-header');
		},
		created() {
			EventBus.$on('collapse-app-header', this.collapseAppHeader);
			EventBus.$on('expand-app-header', this.expandAppHeader);
		},
		destroyed() {
			EventBus.$off('collapse-app-header');
			EventBus.$off('expand-app-header');
		},
	}
</script>

<style lang="scss">
	@import 'globalStyles';
	.header {
		position: fixed;
		top: 0;

		width: 100%;
		max-width: 100vw;

		z-index: $zTopInteractionLayer + 2;
		&.order-confirmation {
			height: 5em;
		}
		&.hide {
			display: none;
		}
	}
	@include mobile {
		.header {
			position: absolute;
			&.item-detail,
			&.checkout,
			&.order-confirmation {
				position: relative;
			}
			&.order-confirmation {
				height: $mobileNavigationHeight;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/header/AppHeader/AppHeader.vue